<template>
  <el-select
    :value="valueTitle"
    :clearable="clearable"
    :allow-create="allowcreate"
    filterable
		
    @clear="clearHandle"
		:filter-method="input"
    v-model="valueTitle"
    ref="select"
    style="width: 100%;"
    :placeholder="placeholder"
    :size="size"
    :disabled="disabled"
    class="options"
    @visible-change="scroll">
    <el-option :value="valueId" :label="valueTitle" class="treelist">
      <el-tree
        id="tree-option"
        ref="selectTree"
        :accordion="accordion"
        :data="options"
        :props="props"
        :node-key="props.keyValue"
				highlight-current
				:current-node-key="currentKeyValue"
        :default-expanded-keys="defaultExpandedKey"
        @node-click="handleNodeClick"
        :expand-on-click-node="false"
        style="width: 100%;"
				:filter-node-method="filterNode"
				
        >
        <span :class="data[props.keyValue]==valueId?'curNode':''" slot-scope="{ node, data }">
          <span>
            <img src="/static/images/folder-open.png" class="node-icon" v-if="node.expanded==true"/>
            <img src="/static/images/folder.png" class="node-icon" v-if="node.expanded==false"/>
          </span>
          <span>{{ node.label }}</span>

        </span>
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>
import * as util from "@/utils/util.js"
export default {
  name: "TreeSelect",
  props:{
    props:{
          type: Object,
          default: function(){
            return {
              value:'ID',             // ID字段名
              label: 'label',         // 显示名称
              PathKey: 'PathKey',     //pathKey
              children: 'children'    ,// 子级字段名
              pid: '0',
              keyValue: 'AutoID'
            };

          }
        },

    // 选项列表数据(树形结构的对象数组)
    options:{ type: Array, default: function(){return [];} },

    // 初始值
    value:{ type: String, default: null },
    label:{ type: String, default: null },
    // 初始值pathkey
    oldpathKey:{ type: String, default: null },
    // nodeDey初始值
    keyValue:{ type: String, default: null },

    // 可清空选项
    clearable:{ type:Boolean, default: false },

    // 自动收起
    accordion:{ type:Boolean, default: false },

    // 创建项目
    allowcreate:{ type:Boolean, default: false },
    // 禁用
    disabled:{ type:Boolean, default: false },

    //placeholder
    placeholder: {type: String, default: '请选择'},

    //控件大小
    size: {type: String, default: 'mini'}
  },
  data() {
    return {
      valueId: null,
      valueTitle:'',
      pathKey: '',
      defaultExpandedKey:[],
      currentKeyValue: '',
			dingShiQiArr: [],	//定时器列表
			filterValue: '',
    }
  },
	created(){
		
	},
  mounted(){
	  
    this.valueId = this.value;    // 初始值
    this.valueTitle=this.label;
    this.currentKeyValue=this.keyValue;
    //console.log(this.currentKeyValue);
		if(this.options.length>0){
			this.defaultExpandedKey.push(this.options[0][this.props.keyValue]);
			
			//console.log('this.options[0][this.props.keyValue]', this.options[0][this.props.keyValue]);
		}
		this.defaultExpandedKey.push(this.valueId);
		
		//console.log(this.defaultExpandedKey, this.props);
		
    this.initHandle();
  },
  beforeDestroy(){
  	//console.log('beforeDestroy', this.dingShiQiArr.length,this);
  	
  	this.dingShiQiArr.forEach(item=>{
  		clearTimeout(item);
  	})
  },
  methods: {
    // 初始化值
    initHandle(){
      if(this.valueId){
        
        //this.valueTitle = this.$refs.selectTree.getNode(this.valueId)[this.props.label]     // 初始化显示
        this.$refs.selectTree.setCurrentKey(this.valueId)       // 设置默认选中
        this.defaultExpandedKey.push(this.valueId);      // 设置默认展开
      }
      this.initScroll()
    },

    // 初始化滚动条
    initScroll(){
      this.$nextTick(()=>{
        let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0]
        let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar')
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;'
        scrollBar.forEach(ele => ele.style.width = 0);
				
				if(this.currentKeyValue){
					this.$refs.selectTree.setCurrentKey(this.valueId);
					
					this.defaultExpandedKey.push(this.$refs.selectTree.getCurrentNode()?.ID);
				}
				
      })
    },
    scroll(flag){
      //console.log('flag:',flag, this.valueId);
      if(flag){
        let t = setTimeout(()=>{
          this.$nextTick(()=>{
            let dom=document.querySelector('.curNode');
            if(dom){
              //console.log(dom);
              let el_window_lastRow_top = dom.getBoundingClientRect().bottom - 35;

              let list=document.querySelector('.treelist');
              let list_top=list.getBoundingClientRect().top + 50;
              
							list.scrollTop=el_window_lastRow_top - list_top;
              
            }
						
						if(this.valueId){
							this.$refs.selectTree.setCurrentKey(this.valueId);
						}
						
						
          })
        },300);
				
				this.dingShiQiArr.push(t);
				
      }
    },
    // 切换选项
    handleNodeClick(node){
      //console.log(node);
      this.$refs.select.blur()
      this.valueTitle = node[this.props.label]
      this.valueId = node["ID"]||'0'
      this.pathKey = node['PathKey']||''
      this.$emit('getValue',this.valueTitle,this.valueId,this.pathKey,node)
      this.defaultExpandedKey = []
      this.currentKeyValue=node[this.props.keyValue]||'';
			this.filterValue='';
			
    },
    // 清除选中
    clearHandle(){
      this.valueTitle = ''
      this.valueId = null
      this.defaultExpandedKey = []
      this.clearSelected()
      this.$emit('clear')
			this.$emit('getValue','','0','0');
			this.filterValue='';
			
      //console.log('clearHandle')
    },

    // 清空选中样式
    clearSelected(){
      let allNode = document.querySelectorAll('#tree-option .el-tree-node')
      allNode.forEach((element)=>element.classList.remove('is-current'))
    },
		filterNode(value, data) {
			//console.log(value, data);
			//return true;
			//if (!this.filterValue) return true;
			if(this.filterValue){
				return data.label.indexOf(this.filterValue) !== -1;
			}
			else{
				return true;
			}
		},
		input(val){
			//console.log('input', val);
			this.filterValue=val;
			
			if(val==''){
			  this.clearHandle();
			}
			
			//console.log('input value', val)
			this.$refs.selectTree.filter(val);
		}
  },

  watch: {
    value2(val){
      this.valueId = this.value
      if(this.value==''){
        this.clearHandle();
      }
			//console.log('watch value', val)
			this.$refs.selectTree.filter(val);
    },
		oldpathKey(val){
			this.pathKey=val;
		}
  },

  directives: {
    //注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector('input').focus()
        // 自动全选
        el.querySelector('input').select()
      }
    },
  },
}
</script>

<style scoped>
	/deep/ .el-scrollbar .el-select-dropdown__wrap{
		max-height: 455px !important;
	}
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
    height: auto;
    max-height: 455px;
		/* width: 295px; */
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
    background-color: #FFFFFF;
  }
  .el-select-dropdown__item.selected{
    font-weight: normal;
  }
  ul li >>>.el-tree .el-tree-node__content{
    height:auto;
    padding: 0 20px;
  }
  .el-tree-node__label{
    font-weight: normal;
  }
  .el-tree >>>.is-current .el-tree-node__label{
    color: #FFFFFF;
    font-weight: 700;
  }
  .el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{
    color:#606266;
    font-weight: normal;
  }

</style>
<style>
  .el-scrollbar__bar.is-vertical{
    display: none !important;
  }
</style>
